// extracted by mini-css-extract-plugin
export default {"distribute_button":"DistributeButton_distribute_button__F3aDi","clear":"DistributeButton_clear__Ji1Th"};